// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/admin/assets.proto (package guardianai.v1.admin, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/admin/assets.proto.
 */
export const file_guardianai_v1_admin_assets: GenFile = /*@__PURE__*/
  fileDesc("CiBndWFyZGlhbmFpL3YxL2FkbWluL2Fzc2V0cy5wcm90bxITZ3VhcmRpYW5haS52MS5hZG1pbiJKChJVcGxvYWRBc3NldFJlcXVlc3QSEAoIZmlsZW5hbWUYASABKAkSFAoMY29udGVudF90eXBlGAIgASgJEgwKBGRhdGEYAyABKAwiIgoTVXBsb2FkQXNzZXRSZXNwb25zZRILCgN1cmwYASABKAkycAoMQXNzZXRTZXJ2aWNlEmAKC1VwbG9hZEFzc2V0EicuZ3VhcmRpYW5haS52MS5hZG1pbi5VcGxvYWRBc3NldFJlcXVlc3QaKC5ndWFyZGlhbmFpLnYxLmFkbWluLlVwbG9hZEFzc2V0UmVzcG9uc2VCHVobZ3VhcmRpYW5haS92MS9hZG1pbjthZG1pbnYxYgZwcm90bzM");

/**
 * @generated from message guardianai.v1.admin.UploadAssetRequest
 */
export type UploadAssetRequest = Message<"guardianai.v1.admin.UploadAssetRequest"> & {
  /**
   * Filename, e.g., "hero-image.png"
   *
   * @generated from field: string filename = 1;
   */
  filename: string;

  /**
   * MIME type, e.g., "image/png"
   *
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * Raw file bytes
   *
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;
};

/**
 * @generated from message guardianai.v1.admin.UploadAssetRequest
 */
export type UploadAssetRequestJson = {
  /**
   * Filename, e.g., "hero-image.png"
   *
   * @generated from field: string filename = 1;
   */
  filename?: string;

  /**
   * MIME type, e.g., "image/png"
   *
   * @generated from field: string content_type = 2;
   */
  contentType?: string;

  /**
   * Raw file bytes
   *
   * @generated from field: bytes data = 3;
   */
  data?: string;
};

/**
 * Describes the message guardianai.v1.admin.UploadAssetRequest.
 * Use `create(UploadAssetRequestSchema)` to create a new message.
 */
export const UploadAssetRequestSchema: GenMessage<UploadAssetRequest, {jsonType: UploadAssetRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_assets, 0);

/**
 * @generated from message guardianai.v1.admin.UploadAssetResponse
 */
export type UploadAssetResponse = Message<"guardianai.v1.admin.UploadAssetResponse"> & {
  /**
   * Public URL to the uploaded asset
   *
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * @generated from message guardianai.v1.admin.UploadAssetResponse
 */
export type UploadAssetResponseJson = {
  /**
   * Public URL to the uploaded asset
   *
   * @generated from field: string url = 1;
   */
  url?: string;
};

/**
 * Describes the message guardianai.v1.admin.UploadAssetResponse.
 * Use `create(UploadAssetResponseSchema)` to create a new message.
 */
export const UploadAssetResponseSchema: GenMessage<UploadAssetResponse, {jsonType: UploadAssetResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_assets, 1);

/**
 * @generated from service guardianai.v1.admin.AssetService
 */
export const AssetService: GenService<{
  /**
   * @generated from rpc guardianai.v1.admin.AssetService.UploadAsset
   */
  uploadAsset: {
    methodKind: "unary";
    input: typeof UploadAssetRequestSchema;
    output: typeof UploadAssetResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_admin_assets, 0);

